export default {
  data() {
    return {
      resultRdvOrder:null,
      resultRdvDateHeure:null,
      titulaire:null,
      adresse:null
    }
  },
  mounted() {
    var sessionSouscription = this.$globalService.getSessionSouscription();
    if(sessionSouscription == null || sessionSouscription.resultDossierScan == null || sessionSouscription.resultDossierScan.fullDocuments == null){
      this.loading = false;
      this.$dialog.notify.error(this.$root.errorMessage, {
        position: 'bottom-right',
        timeout: 5000
      })
      return;
    }
    this.resultRdvOrder = sessionSouscription.resultRdvOrder;
    this.resultRdvDateHeure = sessionSouscription.resultRdvDateHeure;
    this.titulaire = sessionSouscription.titulaire;
    this.adresse = sessionSouscription.eligibilite.adresse;
  },
  methods: {
    gotoEnd: function() {
      this.$router.push({name: 'Final'});
    }
  }

}